import { adminAxiosInstance } from "../../common/axiosInstance"

export function viewMedia(uuid) {
  return adminAxiosInstance.get(`/media/view-media/${uuid}`);
}
